<template>
    <div>
        <el-form :model="formData" :rules="rules" ref="formData" label-width="120px" size="mini">
            <div class="flex">
                <el-form-item class="sub" prop="vc_module" label="模块" >
                    <el-input v-model="formData.vc_module" size="mini" v-if="canEdit" ></el-input>
                    <div class="mrA" v-else>{{formData.vc_module}}</div>
                </el-form-item>
                <el-form-item class="sub" prop="vc_label_key" label="标签名" >
                    <el-input v-model="formData.vc_label_key" size="mini" v-if="canEdit" ></el-input>
                    <div class="mrA" v-else>{{formData.vc_label_key}}</div>
                </el-form-item>
            </div>

            <el-form-item prop="vc_description" label="说明" >
                <el-input v-model="formData.vc_description" size="mini" v-if="canEdit" ></el-input>
                <div class="mrA" v-else>{{formData.vc_description}}</div>
            </el-form-item>
            <el-form-item prop="i_state"  label="是否启用">
                <el-radio-group v-model="formData.i_state" :disabled="!canEdit">
                    <el-radio :label='-1'>禁用</el-radio>
                    <el-radio :label='1'>启用</el-radio>
                </el-radio-group>
            </el-form-item>
            <div class="flex">
                <el-form-item class="sub" prop="vc_lruname" label="录入人" >
                    <div class="mrA" >{{formData.vc_lruname}}</div>
                </el-form-item>
                <el-form-item class="sub" prop="dt_createtime" label="录入时间" >
                    <div class="mrA" >{{formData.dt_createtime}}</div>
                </el-form-item>
            </div>

        </el-form>
        <el-table border  ref="sgtableyy" size="mini" :data="i18nList" :height="200" :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true">
            <el-table-column
                    v-for="col in tableColumns"
                    :key="col.key"
                    :prop="col.key"
                    :label="col.vc_name"
                    :align="col.key === 'vc_lang' ? 'center':'left'"
                    :width="col.key === 'vc_lang' ? '200' : undefined">
                <template #header>
                    <span class="red-star" v-if="col.required" >*</span><span>{{ col.vc_name }}</span>
                </template>
                <template slot-scope="scope">
                    <el-input v-model="scope.row[col.key]" size="mini" v-if="canEdit&&col.key!='vc_lang'" ></el-input>
                    <span v-else>{{scope.row[col.key]}}</span>
                </template>
            </el-table-column>
        </el-table>
         <div  class="center">
            <el-button type="primary" @click="save('formData')" :disabled="disabled" :class="baseerp+'btn'" size="mini" v-if="canEdit">{{$t('button_save')}}</el-button>
            <el-button type="primary" @click="editForm" :disabled="disabled" :class="baseerp+'btn'" size="mini" v-if="!canEdit">{{$t('button_edit')}}</el-button>
            <el-button @click="cancel" size="mini">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp, baseApp, file_url, baseVersion} from "@/utils/baseUrl";
    import {language} from '@/locales/selection'

    export default {
        name: "AddPage",
        components: {},
        props: {
            data:{
                type:Object,
                required: true,
                // default:()=>({})
            }
        },
        data() {
            return {
                tableHeight: 0,
                baseerp: '',
                formData:{
                    vc_module:'',
                    vc_label_key:'',
                    vc_description:'',
                    vc_lruname:sessionStorage.getItem("lruname"),
                    dt_createtime:'',
                    i_state:1,
                },
                canEdit:false,
                disabled:false,
                rules:{
                    vc_module:[{required: true,message:'模块不能为空'}],
                    vc_label_key:[{required: true,message:'标签名称不能为空'}],
                    vc_description:[{required: true,message:'说明不能为空'}],
                    i_state:[{required: true,message:'是否启用不能为空'}],
                },
                langList:language,
                i18nList:[],
                new:0,
            }
        },
        computed: {
            tableColumns() {

                // 2. 基础固定字段（始终展示）
                const baseFixedList = [
                    // { vc_name: 'ID', key: 'i_id' },
                    { vc_name: '语言', key: 'vc_lang',required: true  },
                    { vc_name: '名称', key: 'vc_text' ,required: true},
                ];
                return baseFixedList;

            },

        },
        watch: {
            '$root.workSize': {
                handler(n, o) {
                    this.onResize(n);
                },
                deep: true,
            },
        },
        activated() {
            this.onResize();
        },
        beforeMount(){
            console.log(this.data,'this.data')
            if(this.data.type=='add'){
                this.i18nList=this.langList.map(item=>({
                    i_id:0,
                    vc_lang:item.i_id,
                    vc_text:''
                }))
                this.canEdit=true;
            }else{
                console.log('editItem')
                this.editItem(this.data.data.vc_label_key);
            }
        },
        mounted() {
            //this.getUnitGroupList()

            this.baseerp = baseerp;
            this.formData.dt_createtime=this.getCurrentDate();

            this.$nextTick(() => {
                this.onResize();
            });



        },
        methods: {
            onResize(n) {
                if (n == undefined) n = this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight = n.h - (n.h) * 0.3;
                if (this.tableHeight < 60) this.tableHeight = 60;
            },
            cancel(){
                if(this.new==1){
                    this.$emit('success');
                    this.$emit('close')
                }else{
                    this.$emit('close')
                }

            },

            inputChange(e,type){
                // console.log(e,type,'inputChange')
                if(type=='vc_name'){
                    this.$set(this.i18nList[0],'vc_name',e)
                }else if(type=='vc_name_en'){
                    this.$set(this.i18nList[1],'vc_name',e)

                }else if(type=='vc_showname'){
                    this.$set(this.i18nList[0],'vc_showname',e)

                }else if(type=='vc_sname'){
                    this.$set(this.i18nList[0],'vc_sname',e)

                }
            },

            save(formName){
                // console.log(this.formData,'formData',formName)

                this.$refs[formName].validate((valid)=>{
                    if(valid){
                        for (let i = 0; i < this.i18nList.length; i++) {
                            const row = this.i18nList[i];

                            // 2. 遍历表头配置，找出所有 required: true 的字段
                            for (const col of this.tableColumns) {
                                if (col.required) {
                                    // 3. 获取当前行对应字段的值
                                    const value = row[col.key];

                                    // 4. 判断是否为空（兼容 null, undefined, 空字符串, 纯空格）
                                    if (value === null || value === undefined || String(value).trim() === '') {
                                        // 5. 发现空值，弹出友好提示并终止提交
                                        this.$message.warning(`第 ${i + 1} 行的【${col.vc_name}】不能为空！`);
                                        return; // 直接中断方法，不往下执行
                                    }
                                }
                            }
                        }
                        /*let i18nList=this.i18nList.map(item => ({
                            ...item,
                            i_pid: this.formData.i_id
                        }));*/
                        //let param=this.formData;
                        //param.unitGroupList=this.tableData;
                        //param.i18nList=i18nList;
                        //console.log(param,'param')
                        //return
                        //if(this.data.type=='add'){
                        //    this.addItem(param)
                        //}else{
                        //    this.editItem(param)
                        //}
                        this.addItem()
                    }else{
                        return false
                    }
                })
            },
            editForm(){
                this.canEdit=true
                // this.getUnitGroupList()

            },

            //新增
            async addItem(val){
                this.disabled=true
                let param={
                    "vc_module": this.formData.vc_module,
                    "vc_label_key": this.formData.vc_label_key,
                    "vc_description":this.formData.vc_description,
                    "i_state":this.formData.i_state,
                    "sub":this.i18nList
                };
                console.log(param,'param')
                //return
                let res=await API.save(param);
                if ( res.code == 1 ){
                    this.disabled=false;
                    this.editItem(res.data.vc_label_key);
                    this.new=1;
                    this.$emit('success');
                    //this.$emit('close','save')
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.disabled=false
                }
            },
            //
            async editItem(key){
                let param={
                    "vc_label_key":key,
                };
                let res=await API.detail(param);
                if ( res.code == 1 ){
                    this.canEdit=false;
                    this.formData.vc_module=res.data.vc_module;
                    this.formData.vc_label_key=res.data.vc_label_key;
                    this.formData.vc_description=res.data.vc_description;
                    this.formData.i_state=res.data.i_state;
                    this.formData.vc_lruname=res.data.vc_lruname;
                    this.formData.dt_createtime=res.data.dt_createtime;
                    this.i18nList=res.data.sub

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.disabled=false
                }
            },
            getCurrentDate() {
                const now = new Date()

                const year = now.getFullYear()
                const month = String(now.getMonth() + 1).padStart(2, '0')
                const day = String(now.getDate()).padStart(2, '0')

                return `${year}-${month}-${day}`
            },
        },

    }
</script>

<style lang="scss" scoped>
    .flex{
        display: flex;
    }
    .sub{
        flex:1 1 0;
    }
    .center{
        text-align: center;
    }
    /deep/{
        .el-form-item__content{
            width: calc(100% - 145px);
        }
        .el-select{
            margin-right: 0 !important;
            width: 100% !important;
        }
    }
    .el-radio{
        margin-right: 5px !important;
    }
    .red-star{
        color: red;
    }
</style>